import { infiniteQueryOptions } from '@tanstack/react-query';

import { apiEntityViewsFetch } from '..';
import { GetEntityTeamRes } from '../entity/types';
import { ENTITY_VIEWS_QUERY_KEYS, GetEntityViewsTeamAssociatesParams } from './queries';

export const _getEntityViewsTeamAssociatesInfinite = ({
  id,
  status,
  role,
  search,
}: Omit<GetEntityViewsTeamAssociatesParams, 'page' | 'limit'>) =>
  infiniteQueryOptions({
    enabled: !!id,
    queryKey: [ENTITY_VIEWS_QUERY_KEYS.teamAssociates, id, 'infinite', { status, role, search }],
    queryFn: ({ pageParam = 1 }) =>
      apiEntityViewsFetch<GetEntityTeamRes>(`/${id}/team-associates`, {
        params: { status, role, search, page: pageParam, limit: 20 },
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.page < Math.ceil(lastPage.total / lastPage.limit) ? lastPage.page + 1 : undefined,
    refetchOnMount: true,
    retry: 1,
  });
